export default "__VITE_ASSET__DnFr4vIb__"